import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const PolicyClaimsChart = ({chartData}) => {

  const months = chartData?.map((item) => item.month); 
  const policyAmounts = chartData?.map((item) => item.policy_amount);
  const claimAmounts = chartData?.map((item) => item.claim_amount);

  const data = {
    labels: months,
    datasets: [
      {
        label: 'Applied Policies',
        data: policyAmounts,
        backgroundColor: '#f09c51',
        barThickness: 10,
      },
      {
        label: 'Claims',
        data: claimAmounts,
        backgroundColor: '#2d49fa',
        barThickness: 10,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          color: '#6b6b6b',
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: '#a0a0a0',
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: '#a0a0a0',
        },
        grid: {
          color: '#e0e0e0',
          borderDash: [2, 2],
        },
      },
    },
  };

  return (
    <div className="col-xl-12 col-lg-12 order-lg-1">
        <div className="card">
            <div className="card-body pb-0">
                <div className='w-full mb-2' style={{
                    display: 'flex',
                    justifyContent: "space-between",
                    alignItems: 'center',
                    gap: '10px',
                }}>
                    <h4 className="header-title">Policy Claims</h4>
                    <span style={{ textAlign: 'right', color: '#a0a0a0' }}>Last 12 Months</span>
                </div>
                <div style={{ width: '100%', height: '300px', padding: '20px' }}>
                    <Bar data={data} options={options} />
                </div>
            </div>
        </div>
    </div>
  );
};

export default PolicyClaimsChart;
